const msg = {
  messageDefault: 'Bạn không được bỏ trống trường này.',
  messageLinhVucTT: 'Bạn cần bổ sung lĩnh vực thanh tra.',
  messageHinhThucTT: 'Bạn cần bổ sung hình thức thanh tra.',
  ten: 'Vui lòng điền tên đầy đủ của công dân!',
  tinhThanh: 'Vui lòng chọn tỉnh thành nơi công dân cư trú!',
  quanHuyen: 'Vui lòng chọn quận huyện nơi công dân cư trú!',
  phuongXa: 'Vui lòng chọn phường xã nơi công dân cư trú!',
  toDanPho: 'Vui lòng chọn tổ dân phố nơi công dân cư trú!',
  ngaytn: 'Vui lòng chọn ngày tiếp nhận!',
  loaiNguoiDD: 'Vui lòng chọn loại người đứng đơn!',
  tenCoQuanDD: 'Vui lòng nhập tên cơ quan!',
  diaChiCoQuanDD: 'Vui lòng nhập địa chỉ cơ quan!',
  soDienThoaiCoQuanDD: 'Vui lòng nhập số điện thoại cơ quan!',
  nguoiUQ: 'Vui lòng điền đầy đủ thông tin người ủy quyền!',
  loaiDon: 'Vui lòng chọn loại đơn!',
  huyCTT: 'Đã huỷ thành công!',
  loaiDT: 'Vui lòng chọn loại đối tượng!',
  loaiLV: 'Vui lòng chọn loại lĩnh vực!',
  loaiLVChiTiet: 'Vui lòng chọn loại lĩnh vực chi tiết!',
  noiDungDon: 'Vui lòng nhập tóm tắt nội dung đơn thư!',
  noiDungHXL: 'Vui lòng nhập nội dung',
  dtBiKhieuTo: 'Vui lòng bổ sung thông tin đối tượng bị khiếu tố!',
  loaiDoiTuongBiKT: 'Vui lòng chọn loại đối tượng bị khiếu tố !',
  tenNguoiBiKT: 'Vui lòng nhập tên người bị khiếu tố',
  cqBiKhieuTo: 'Vui lòng điền đầy đủ thông tin cơ quan bị khiếu tố!',
  huongXL: 'Vui lòng chọn hướng xử lý!',
  cTCDTXSucess: 'Tạo đơn tiếp công dân thường xuyên thành công!',
  UTCDTXSucess: 'Cập nhật tiếp công dân thường xuyên thành công!',
  updateSuccess: 'Cập nhật thành công!',
  createSuccess: 'Thêm mới thành công!',
  trinhSuccess: 'Trình đơn thành công!',
  addTurnSucess: 'Thêm lượt tiếp công dân thường xuyên thành công!',
  dTCDTX: 'Xóa sổ tiếp công dân thành công!',
  thoiHanXuLy: 'Vui lòng chọn thời hạn xử lý',
  noiDungTrinhLanhao: 'Vui lòng nhập nội dung trình lãnh đạo',
  //CivilServant
  maCivilServantCivilServant: 'Vui lòng nhập mã công chức !',
  coQuanQuanLyCivilServant: 'Vui lòng chọn cơ quan quản lý !',
  chucVuCivilServant: 'Vui lòng chọn chức vụ !',
  nguoiDungTenDangNhapCivilServant: 'Vui lòng nhập tên đăng nhập !',
  nguoiDungMatKhauCivilServant: 'Vui lòng nhập mật khẩu !',
  vaiTroCivilServant: 'Vui lòng chọn vai trò !',
  vaiTroMacDinhCivilServant: 'Vui lòng chọn vai trò mặc định !',
  //add ReceptionPeriodical
  lanhDaoTiepPeriodical: 'Vui lòng chọn lãnh đạo tiếp !',
  //add Letter
  nguonDon: 'Vui lòng chọn nguồn đơn !',
  datDonPeriodical: 'Vui lòng chọn đơn để thêm mới',
  //list header letters
  tuNgayVsDenNgay: 'Vui lòng chọn đến ngày lớn hơn từ ngày !',
  deleteLetterSucess: 'Xóa đơn thành công',
  // Letter processing
  trinhDon: 'Đơn đã được trình lên lãnh đạo',
  xuLyDon: 'Xử lý đơn thành công',
  //category
  nameCategory: 'Vui lòng nhập tên danh mục',
  codeCategory: 'Vui lòng nhập mã danh mục !',
  addCategorySucess: 'Thêm mới danh mục thành công !',
  updateCategorySucess: 'Cập nhật danh mục thành công!',
  chuyenXLDSucess: 'Chuyển xử lý đơn thành công',
  delCategorySucess: 'Xóa danh mục thành công!',
  codeCategoryAdministrative: 'Vui lòng nhập mã đơn vị hành chính !',
  nameCategoryAdministrative: 'Vui lòng nhập tên đơn vị hành chính !',
  levelCategoryAdministrative: 'Vui lòng chọn cấp đơn vị hành chính !',
  codeCategoryAdministrativeUnits: 'Vui lòng nhập mã cấp đơn vị hành chính !',
  nameCategoryAdministrativeUnits: 'Vui lòng nhập tên cấp đơn vị hành chính !',
  hoVaTen: 'Vui lòng nhập họ và tên !',
  gioiTinh: 'Vui lòng chọn giới tính !',
  soCMNDHoCHieu: 'Vui lòng nhập số CMND/Hộ Chiếu !',
  noiCap: 'Vui lòng chọn nơi cấp CMND/Hộ Chiếu !',
  ngayCap: 'Vui lòng chọn ngày cấp CMND/Hộ Chiếu !',
  diaChi: 'Vui lòng nhập địa chỉ !',
  dienThoai: 'Vui lòng nhập số điện thoại !',
  email: 'Vui lòng nhập Email !',
  ngaySinh: 'Vui lòng chọn ngày sinh !',
  thanhPho: 'Vui lòng chọn Tỉnh !',
  quocTich: 'Vui lòng chọn quốc tịch !',
  danToc: 'Vui lòng chọn dân tộc !',
  //NationCategory
  nameNation: 'Vui lòng nhập tên dân tộc !',
  codeNation: 'Vui lòng nhập mã dân tộc !',
  //OrganizationCategory
  codeOrganization: 'Vui lòng nhập mã cơ quan !',
  nameOrganization: 'Vui lòng nhập tên cơ quan !',
  selectOrganization: 'Vui lòng chọn cấp cơ quan quản lý!',
  cityOrganization: 'Vui lòng chọn đơn vị hành chính Tỉnh !',
  //ParameterCategory
  codeParameter: 'Vui lòng nhập giá trị tham số !',
  nameParameter: 'Vui lòng nhập tên tham số !',
  //ResidentialGroup
  nameResidentialGroup: 'Vui lòng nhập tên tổ dân phố !',
  //Role
  nameRole: 'Vui lòng nhập tên vai trò !',
  selectRole: 'Vui lòng chọn loại vai trò !',
  //TypeOfTimeOut
  nameTypeOfTimeOut: 'Vui lòng chọn loại thời hạn !',
  quyTrinhXuLy: 'Vui Lòng chọn quy trình xử lý !',
  ngayXuLy: 'Vui lòng chọn số ngày xử lý !',
  thamQuyenGiaiQuyet: 'Vui lòng chọn thẩm quyền gỉai quyết !',
  phongBanGiaiQuyet: 'Vui lòng chọn phòng ban gỉai quyết !',
  coQuanTiepNhan: 'Vui lòng chọn cơ quan tiếp nhận !',
  lyDo: 'Vui lòng nhập lý do',
  canBoXuLy: 'Vui lòng chọn công chức xử lý !',
  phongBan: 'Vui lòng chọn phòng ban !',
  noiDungDinhChi: 'Vui lòng điền nội dung đình chỉ!',
  tooltipButtonAdd: 'Thêm lượt',
  tooltipButtonEdit: 'Sửa',
  tooltipButtonDelete: 'Xóa',
  tooltipButttonAction: 'Xử lý',
  tooltipCategoryAdd: 'Thêm mới',
  fileTypeErr: 'Vui lòng chọn file có định dạng: .doc, .docx, .pdf, .rar, .zip, .jpg, .png',
  filePhotoErr: 'Vui lòng chọn file có định dạng: .jpg, .png',
  fileExcel: 'Vui lòng chọn file có định dạng: .xls, .xlsx',
  fileTypeErr2: 'Vui lòng chọn file có định dạng: .doc, .docx, .pdf, .xls, .xlsx, .rar, .zip, .jpg, .png',
  fileVideoTypeErr: 'Vui lòng chọn file có định dạng: .flv, .mp4',
  fileSizeErr: 'Vui lòng chọn file có dung lượng tối đa là 50Mb',
  fileSizeNull: 'Vui lòng tải tập tin có dữ liệu',
  fileVideoSizeErr: 'Vui lòng chọn file có dung lượng tối đa là 5Mb',
  giaiQuyetDon: 'Giải quyết đơn thành công !',
  dateInvalid: 'Định dạng chưa đúng. Vui lòng nhập lại',
  dataExist: 'Dữ liệu này đã tồn tại trong hệ thống',
  dataInvalid: 'Dữ liệu không hợp lệ',
  emailInvalid: 'Email không đúng định dạng',
  uploadRequire: 'Vui lòng đính kèm tệp tin',
  luuGiaiQuyetDonThanhCong: 'Lưu kết quả giải quyết đơn thành công',
  giaHanTTXM: 'Gia hạn thẩm tra xác minh thành công',
  dinhChiDon: 'Đình chỉ đơn thành công',
  rutDon: 'Rút đơn thành công',
  congDanExist: 'Đã chọn công dân này',
  createKHSuccess: 'Thêm mới kế hoạch thanh tra thành công',
  createKHKTSuccess: 'Thêm mới kế hoạch kiểm tra thành công',
  updateKHSuccess: 'Chỉnh sửa kế hoạch thanh tra thành công',
  updateKHKTSuccess: 'Chỉnh sửa kế hoạch kiểm tra thành công',
  removeKHSuccess: 'Xóa kế hoạch thành công',
  removeKHKTSuccess: 'Xóa kế hoạch kiểm tra thành công',
  saveCuocTTSuccess: 'Lưu cuộc thanh tra thành công',
  saveCuocKTSuccess: 'Lưu cuộc kiểm tra thành công',
  confirmBack: 'Đóng sẽ không lưu những thay đổi mà bạn đã thực hiện. Bạn có muốn đóng không ?',
  confirmChangeSaveLoaiDon: 'Khi thay đổi Loại đơn, tất cả tài liệu đính kèm đã tải lên sẽ bị mất. Bạn có đồng ý ?',
  confirmChangeSaveHXL: 'Khi thay đổi Hướng xử lý, tất cả tài liệu đính kèm đã tải lên sẽ bị mất. Bạn có đồng ý ?',
  confirmChange: 'Khi chọn Hướng xử lý khác thì những file đã tải lên sẽ bị mất. Bạn có muốn tiếp tục không ?',
  chuyenKTDX: 'Chuyển kiểm tra đề xuất thành công.',
  gqdGiaoTTXM: 'Chuyển đơn vị thành công',
  gqdLuuHoSo: 'Lưu hồ sơ thành công',
  gqdLuu: 'Lưu thành công',
  gqdTrinhLanhDao: 'Trình đơn thành công',
  gqdGiaoViec: 'Giao việc thành công',
  gqdTraBaoCao: 'Gửi báo cáo thành công',
  gqdLanhDaoGiaoViec: 'Giao việc thành công',
  gqdGuiDuThao: 'Gửi dự thảo thành công',
  gqdChuyenTheoDoi: 'Chuyển theo dõi thực hiện thành công',
  gqdTraDonThanhCong: 'Trả đơn thành công',
  guiBCSuccess: 'Gửi báo cáo thành công',
  ktdxTraBaoCao: 'Gửi báo cáo KTĐX thành công',
  ktdxTrinhLanhDao: 'Trình đơn thành công',
  ktdxLanhDaoGiaoViec: 'Giao việc thành công',
  // XU_LY_DON
  xldLuu: 'Lưu thành công',
  xldTrinhLanhDao: 'Trình đơn thành công',
  xldYeuCauGapLanhDao: 'Gửi yêu cầu thành công',
  xldLanhDaoGiaoViec: 'Giao việc thành công',
  xldTruongPhongGiaoViec: 'Giao việc thành công',
  xldTruongPhongGiaoViecPhoPhong: 'Giao thành công',
  xldChuyenGiaiQuyetDon: 'Chuyển giải quyết đơn thành công',
  xldLuuHoSo: 'Lưu hồ sơ thành công',
  xldChuyenDon: 'Chuyển đơn thành công',
  xldTraDon: 'Trả đơn chuyển không đúng thẩm quyền thành công',
  xuLyYeuCau: 'Xử lý yêu cầu gặp lãnh đạo thành công',
  thuHoiDon: 'Thu hồi đơn thành công',

  //thanh tra
  saveDoiTuongTTSuccess: 'Lưu đối tượng thanh tra thành công',
  addDoiTuongTTSuccess: 'Thêm mới đối tượng thanh tra thành công',
  ttTienHanhThanhTra: 'Tiến hành thanh tra thành công',
  ttTienHanhKiemTra: 'Tiến hành kiểm tra thành công',
  ttKetThucThanhTra: 'Kết thúc thanh tra trực tiếp thành công',
  ttKetThucKiemTra: 'Kết thúc kiểm tra trực tiếp thành công',
  ttChuyenTheoDoi: 'Chuyển theo dõi thực hiện thành công',
  ttLuuHoSo: 'Lưu hồ sơ thành công',

  // theo doi thuc hien
  tdthLuuHoSo : 'Lưu hồ sơ thành công',
  confirmDonDoc: 'Bạn chưa lưu những thao tác vừa thực hiện trên block Đôn đốc, việc thu gọn block sẽ hủy đi những thao tác mà bạn đã thực hiện. Bạn có muốn thu gọn không?',
  confirmExportExcel: 'Những thay đổi của bạn chưa được lưu, hệ thống sẽ tự động lưu báo cáo?',
  //bao cao dinh ky
  dkLuuHoSo: 'Lưu báo cáo thành công',
  guiTTXMLai: 'Gửi thẩm tra xác minh lại thành công',
  delVideoSuccess: 'Xóa video thành công',
  viewPermission: 'Bạn không có quyền xem chi tiết đơn này',
  // thanh tra trùng
  tttGui: 'Gửi đề xuất thành công'
};

export { msg };



// WEBPACK FOOTER //
// ./src/constants/message.js